/**
 * @file index.js
 * @author Fernando Ruano
 * @description Initialize MissedAppointmentsByStage View.
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './MissedAppointmentsByStageView';

export const mapStateToPropsMissedAppointmentsByStage = mapStateToProps;
export const mapDispatchToPropsMissedAppointmentsByStage = mapDispatchToProps;

export default connect(
  mapStateToPropsMissedAppointmentsByStage,
  mapDispatchToPropsMissedAppointmentsByStage
)(View);
